import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 103 118" fill="none" {...props}>
      <title>{props.title || 'Popular'}</title>
      <g xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.2542 61.0167L9 25.75L21.5 7L44.7583 46.7875"
          fill="#BEEBF6"
          fillOpacity="0.5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M81.4957 61.0167L102.75 25.75L90.2499 7L66.9916 46.7875"
          fill="#BEEBF6"
          fillOpacity="0.5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M55.875 100.75C71.408 100.75 84 88.158 84 72.625C84 57.092 71.408 44.5 55.875 44.5C40.342 44.5 27.75 57.092 27.75 72.625C27.75 88.158 40.342 100.75 55.875 100.75Z"
          fill="#BEEBF6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50 96.875C65.533 96.875 78.125 84.283 78.125 68.75C78.125 53.217 65.533 40.625 50 40.625C34.467 40.625 21.875 53.217 21.875 68.75C21.875 84.283 34.467 96.875 50 96.875Z"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.3792 57.1417L3.125 21.875L15.625 3.125L38.8833 42.9125"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M43.75 56.25H46.875C48.6009 56.25 50 57.6491 50 59.375V81.25"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M43.75 81.25H56.25"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M75.6207 57.1417L96.8749 21.875L84.3749 3.125L61.1166 42.9125"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M84.375 3.125H15.625"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M50 117V109"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M84 103L78 97"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 103L22 97"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M90 73H98"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 73H10"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </Icon>
  )
}
